<template>

    <div>
        <div ref="map" v-if="this.latitude && this.longitude" style="min-height: 300px;"></div>
    </div>

</template>

<script>
    import mixinMapsService from './mixinMapsService';

    const { props } = mixinMapsService;

    export default {
        mixins: [mixinMapsService],

        props: {
            ...props,
            latitude: {
                type: Number,
                default: null
            },
            longitude: {
                type: Number,
                default: null
            },
        },
        computed: {},

        data() {
            return {};
        },
        watch: {
            serviceLoading(isLoading) {
                this.loading = !!+isLoading;
            }
        },
        mounted() {
            if (this.latitude && this.longitude) {
                (async () => {
                    await this.onLoadingGmap();
                    this.buildMap();

                })();
            }
        },
        methods: {
            buildMap() {
                var map = new google.maps.Map(this.$refs.map, {
                    zoom: 13,
                    center: {lat: this.latitude, lng: this.longitude},
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: true,
                    streetViewControl: false,
                    rotateControl: true,
                    fullscreenControl: true
                });

                var marker;

                marker = new google.maps.Marker({
                    map: map,
                    draggable: true,
                    animation: google.maps.Animation.DROP,
                    position: {lat: this.latitude, lng: this.longitude}
                });
            }
        }
    };
</script>
